import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { Dispatch, SetStateAction } from 'react';
import { ICmsDocument } from '@features/cms/typescript/index';
import styles from '@features/cms/components/collections/VisualBlock/VisualBlockNavigation/VisualBlockNavigation.styles';
import Heading from '@components/Heading/Heading';
import theme from '@styles/theme';
type PropsType = {
  subpages: ICmsDocument[];
  activeSlug: string;
  categorySlug: string;
  hasProducts?: boolean;
  setNewActiveSlug: Dispatch<SetStateAction<string>> | undefined;
};
const VisualBlockNavigation = ({
  subpages,
  activeSlug,
  categorySlug,
  setNewActiveSlug,
  hasProducts = false
}: PropsType) => {
  const {
    t
  } = useTranslation('common');
  const router = useRouter();
  const changeActiveSlug = (slug: string) => {
    if (setNewActiveSlug) {
      setNewActiveSlug(slug);
    }
    const categoryPath = `/${categorySlug}/${slug}`;
    router.push(categoryPath, undefined, {
      scroll: false
    });
  };
  return <div sx={styles.menu}>
      <div sx={styles.menuItem(activeSlug === '')} onClick={() => changeActiveSlug('')} onKeyDown={e => e.key === 'Enter' && changeActiveSlug('')} role="button" tabIndex={0}>
        <Heading h={6} mobile color={theme.rawColors.neutralWhite} whiteSpace="nowrap">
          {t('aboutCollection')}
        </Heading>
      </div>
      {hasProducts && <div sx={styles.menuItem(activeSlug === 'products')} onClick={() => changeActiveSlug('products')} onKeyDown={e => e.key === 'Enter' && changeActiveSlug('products')} role="button" tabIndex={0}>
          <Heading h={6} mobile color={theme.rawColors.neutralWhite} whiteSpace="nowrap">
            {t('products.all')}
          </Heading>
        </div>}
      {subpages && subpages.map(subpage => <div key={subpage.id} sx={styles.menuItem(activeSlug === subpage.baseData?.slug)} onClick={() => changeActiveSlug(subpage.baseData?.slug as string)} onKeyDown={e => e.key === 'Enter' && changeActiveSlug(subpage.baseData?.slug as string)} role="button" tabIndex={0}>
            <Heading h={6} mobile color={theme.rawColors.neutralWhite} whiteSpace="nowrap">
              {subpage.baseData?.name}
            </Heading>
          </div>)}
    </div>;
};
VisualBlockNavigation.displayName = 'VisualBlockNavigation';
export default VisualBlockNavigation;